import styled, { keyframes } from 'styled-components'

const showIcons = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`

const showHideTooltip = keyframes`
  0%{
    opacity: 0;
    transform: translateY(10px);
    display: block;
  }
  5%{
    opacity: 1;
    transform: translateY(0px);
  }
  95%{
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    display: none;
  }
`

export const Container = styled.div`
  margin-top: 29px;
  height: 200px;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

export const Wrapper = styled.div`
  width: 20px;
  height: 200px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ButtonOpenClose = styled.div`
  width: 20px;
  border-top: 1px solid #fff;
  pointer-events: all;

  .button-collapse {
    margin-top: -6px;
    margin-left: -1px;
    transform-origin: center;
    transform: rotate(180deg);
    transition: all .4s ease-out;

    &.open {
      transform: rotate(360deg);
    }
  }
  
`;

export const ContainerButtons = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 0;
  transform: translateY(-120px);
  opacity: 0;
  transition: all .3s ease-in-out;

  &.open {
    transform: translateY(-4px);
    opacity: 1;
  }

  svg {
    cursor: pointer;
    margin-bottom: 8px;
    opacity: 0;
    animation: ${showIcons} .4s ease-out forwards;
    pointer-events: all;
  }
`;

export const WrapperButtons = styled.div`
  width: 20px;
  height: 0px;
  overflow: hidden;

  &.open {
    height: 140px;
  }
`
export const Tooltip = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 8px;
  letter-spacing: 1px;
  top: 104px;
  right: 50px;
  width: auto;
  min-width: 100px;
  color: #FFF;
  padding: 2px 6px;
  border-radius: 4px;
  height: 20px;
  background: rgba(17, 36, 38, 0.8);

  animation: ${showHideTooltip} 3s ease-in-out forwards;

  &:after{
    content: '';
    position: absolute;
    right: -8px;
    top: 35%;
    width: 0;
    height: 0;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid rgba(17, 36, 38, 0.8);
    transform: rotate(-90deg);
  }
`
